import React from 'react';
import cx from 'classnames';

// components
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import ZolaLogo from '@zola/zola-ui/src/components/ZolaLogo';

// interface
import type { WPublicGuestCollectionDetailView } from '@zola/svc-web-api-ts-client';

// style
import styles from './WeddingDetailsPanel.module.less';

interface WeddingDetailsPanelProps {
  details: WPublicGuestCollectionDetailView;
  onClick: () => void;
}

const WeddingDetailsPanel: React.FC<WeddingDetailsPanelProps> = ({ details, onClick }) => {
  const image = details.image_link ? (
    <img className={styles.image} src={details.image_link} alt="placeholder" />
  ) : (
    <video autoPlay muted loop playsInline className={styles.image}>
      <source
        src="https://zola-web-assets.s3.amazonaws.com/static-assets/videos/super-link/super-link-animation-rebrand.mp4"
        type="video/mp4"
      />
    </video>
  );

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${process.env.ASSET_PATH}/static-preauth/images/AddressCollection/mobileFormBackground.svg)`,
      }}
    >
      <ZolaLogo className={cx(styles.logo, styles.logoRebrand)} />
      <div>
        <h1 className={styles.header}>
          {details.owner_first_name} & {details.partner_first_name} request your address and info.
        </h1>
        <p className={styles.subHeader}>
          Something special&apos;s headed your way{' '}
          <span role="img" aria-label="love-letter-emoji">
            💌
          </span>{' '}
          Don&apos;t worry—your details won&apos;t be shared with anyone else.
        </p>
      </div>
      <div
        className={styles.photoSection}
        style={{
          backgroundImage: `url(${process.env.ASSET_PATH}/static-preauth/images/AddressCollection/polaroid.svg)`,
        }}
      >
        {image}
        <p className={styles.weddingDate}>
          {details.wedding_date &&
            new Date(details.wedding_date).toLocaleString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              timeZone: 'UTC',
            })}
        </p>
      </div>
      <ButtonV3 className={styles.startButton} onClick={onClick}>
        Fill Out Form
      </ButtonV3>
    </div>
  );
};

export default WeddingDetailsPanel;
